module.exports = __webpack_public_path__ + "img/logo-tf1.png";